import React from "react"
import moment from 'moment';
import { BarYear } from "../../components/BarChart"
import { Card, CardTitle } from "../../components/Card"
import { ImArrowDown, ImArrowUp } from "react-icons/im"
import { ModalActions, ModalUserList } from "../../components/Modal"
import {
  formattedArrayBars,
  formattedBar,
  formattedList,
  getYearPercent,
  getYearProducers,
} from "../../core/utils/formatJouney"
import { Spinner } from "../../components/Loading"
import { EmptyGraph } from "../../components/Empty"
import { Grid } from "../../components/Table"
import "./styles.scss"

const COLORS = ["rgb(239, 130, 93)", "rgb(33, 150, 243, .6)", "rgb(76, 175, 80, .6)", "#C44C14"]

const ProviderJourneyScreen = ({
  data,
  users,
  isOpenUsers,
  openUsersModal,
  setOrder,
  checked,
  onCheckedChange,
  onChange,
  order,
  setIsOpenActions,
  isOpenActions,
  closeModal,
  onHistory,
  loading,
  loadingUsers,
  year,
  trailPosts,
  projectId,
  content
}) => {
  
  return (
    <>
      <div>
        {loading ? (
          <div className="loading-content">
            <Spinner color="primary" />
          </div>
        ) : (!formattedList(data, year) || !formattedList(data, year).length) ? (
          <EmptyGraph />
        ) : (
          <div className="journey-screen">
            <div className="indicador-container">
              <Card className="no-border">
                <CardTitle className="center" title="JORNADA DO PRODUTOR" />
                <div className={`graph margin`}>
                  <BarYear
                    colors={COLORS}
                    data={formattedBar(projectId, data, year)}
                    bars={formattedArrayBars(data, year)}
                    formatterLegend={(value) => value.split("[0]")[0]}
                  />
                </div>
              </Card>
            </div>
            
            <div className="card-list">
              {formattedList(data, year).map((item, index) => {
                return (
                  <>
                    <ProviderList
                      loading={loadingUsers}
                      color={COLORS[index % COLORS.length]}
                      item={item}
                      lastYearProducersCount={getYearProducers(data, item?.Trilha, year)}
                      percent={getYearPercent(
                        data,
                        item.Trilha,
                        year,
                        item?.Projeto,
                        item?.contagem_projeto || 0,
                        true
                      )}
                      users={users}
                      checked={checked}
                      isOpen={isOpenUsers === item.Trilha}
                      onClick={() => openUsersModal(item  )}
                      closeModal={closeModal}
                      changeSort={() => setOrder(!order)}
                      changeCheck={onCheckedChange}
                      onSearch={onChange("search", true)}
                      onSelectInput={onChange("select")}
                      onActions={() => setIsOpenActions(true)}
                      isOpenActions={isOpenActions}
                      closeModalActions={() => setIsOpenActions(false)}
                      onHistory={(id) => onHistory(id)}
                      posts={trailPosts}
                    />
                  </>
                )
              })}
            </div>
          </div>
        )}
        <ModalUserList
          loading={loadingUsers}
          checked={checked}
          data={users}
          changeSort={() => setOrder(!order)}
          modalIsOpen={isOpenUsers}
          closeModal={closeModal}
          changeCheck={onCheckedChange}
          onSearch={onChange("search", true)}
          onSelectInput={onChange("select")}
          onActions={() => setIsOpenActions(true)}
          onHistory={(id) => onHistory(id)}
        />
        <ModalActions
          defaultPostIds={trailPosts}
          selectedsUsers={checked}
          modalIsOpen={isOpenActions}
          closeModal={() => setIsOpenActions(false)}
        />
        {content && content.length > 0 && <Grid rows={content.filter(item => item.Titulo)} columns={columns} />}
      </div>
    </>
  )
}

const columns = [
  {
    id: 0,
    label: 'Conteúdo',
    field: 'Titulo',
    width: 'calc(100% - 720px)',
  },
  {
    id: 1,
    field: 'Produtor',
    label: 'Produtor',
    width: '180px',
    // cellRenderer
  },
  {
    id: 2,
    field: 'Tecnico',
    label: 'Tecnico',
    width: '180px',
    // cellRenderer
  },
  {
    id: 3,
    field: 'Projeto',
    label: 'Projeto',
    width: '180px',
    // cellRenderer
  },
  {
    id: 4,
    label: 'Data do Envio',
    field: 'DataEnvio',
    width: '180px',
    cellRenderer:({value}) => <div className='rgt-cell-inner rgt-text-truncate'>{value && moment(value).format("DD/MM/YYYY")}</div>
  },
  // {
  //   id: 5,
  //   label: 'Data da Leitura',
  //   field: 'DataLeitura',
  //   width: '180px',
  //   cellRenderer:({value}) => <div className='rgt-cell-inner rgt-text-truncate'>{value && moment(value).format("DD/MM/YYYY")}</div>
  // },
  {
    id: 5,
    field: 'Link',
    label: 'Link',
    width: '180px',
    cellRenderer:({value}) => <div className='rgt-cell-inner rgt-text-truncate'><a href={value}>Ver conteúdo</a></div>
  },
  // {
  //   id: 7,
  //   field: 'userId',
  //   label: 'Evidencia',
  //   cellRenderer:({value}) => <div className='rgt-cell-inner rgt-text-truncate'><a href={`/evidence/${value}`}>Ver evidência</a></div>
  // },
]

export default ProviderJourneyScreen

const ProviderList = ({
  item,
  color,
  percent,
  lastYearProducersCount,
  onClick,
}) => {
  return (
    <>
      <div className="div-center">
        <div className="card-provider" style={{ backgroundColor: color }} onClick={onClick}>
          <div className="card-items-provider">
            <div className="card-percent-title">
              <text className="card-percent">{lastYearProducersCount || 0}</text>
              <div className="card-percent-arrow">
                {item && item.Produtores && percent?.value >= 100 ? (
                  <ImArrowUp className="card-icon" />
                ) : (
                  <ImArrowDown className="card-icon warning" />
                )}
              </div>
            </div>
            <div className="card-percent-badge">
              <text
                className={`card-percent ${item && item.Produtores && percent?.value >= 100
                  ? "card-percent--info"
                  : "card-percent--warning"
                  }`}>
                {`${percent?.value}% (${percent.number})`}
              </text>
            </div>
          </div>
        </div>
        <div className="div-title-provider">
          <text className="title" style={{ color }}>
            {item?.Trilha}
          </text>
        </div>
      </div>
    </>
  )
}
